var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from 'theme-ui';
import sizes from './sizes';
export default function ShoppingCartIcon(_a) {
    var { className = '', size = 'small', title } = _a, rest = __rest(_a, ["className", "size", "title"]);
    return (jsx("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", sx: {
            width: sizes[size],
            height: sizes[size],
            verticalAlign: 'middle',
        }, className: className, fill: "none", stroke: "currentColor", strokeWidth: "2", viewBox: "0 0 24 24" }, rest),
        title && jsx("title", null, title),
        jsx("circle", { cx: "9", cy: "21", r: "1" }),
        jsx("circle", { cx: "20", cy: "21", r: "1" }),
        jsx("path", { d: "M1 1h4l2.68 13.39a2 2 0 002 1.61h9.72a2 2 0 002-1.61L23 6H6" })));
}
//# sourceMappingURL=ShoppingCartIcon.js.map